import {
  button,
  iframe,
  iframeContainer,
  videosContainer,
  fallbackContainer,
  fallbackImage,
  fallbackIcon,
} from "../style";
import videoData from "@/i18n/json/media/data.json";
import { getCookie } from "@/lib/cookies";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

const FallBackImage = ({ src, alt }: { src: string; alt: string }) => {
  var videoIdMatch = src.match(
    /(youtube-nocookie\.com|youtube\.com)\/embed\/([^?]+)/
  );
  if (!videoIdMatch || videoIdMatch == null) {
    return <img src="/assets/images/video-unavailable.png" alt={alt} />;
  }

  var videoId = videoIdMatch[2].trim();
  var fallbackImageUrl = `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`;

  return (
    <a href={src} target="_blank" className={fallbackContainer}>
      <img className={fallbackImage} src={fallbackImageUrl} alt={alt} />
      <img
        className={fallbackIcon}
        src="/assets/images/youtube-play-button-shadow.svg"
        alt={alt}
      />
    </a>
  );
};

const VideoItems = () => {
  const [hasConsentForYoutubeVideo, setHasConsentForYoutubeVideo] =
    useState(false);
  useEffect(() => {
    const consentCookie = getCookie("CookieConsent");
    const hasMarketingConsent = consentCookie.includes("marketing:true");
    const hasStatisticsConsent = consentCookie.includes("statistics:true");
    setHasConsentForYoutubeVideo(hasMarketingConsent && hasStatisticsConsent);
  });

  const videos = [...videoData.videos];
  const [videosState, setVideosState] = useState(videos.slice(0, 4));
  const { t } = useTranslation();

  const loadMoreVideosHandler = () => {
    setVideosState(videos);
  };

  return (
    <div className={videosContainer}>
      {videosState.map((item, index) => {
        return (
          <div
            key={index}
            className={iframeContainer}
            title={t(`media.video-section.videos.${index}.title`)}
          >
            {hasConsentForYoutubeVideo ? (
              <iframe className={iframe} src={item.url} />
            ) : (
              <FallBackImage
                src={item.url}
                alt={t(`media.video-section.videos.${index}.title`)}
              />
            )}
          </div>
        );
      })}
      {videosState.length === 4 ? (
        <button
          type={"button"}
          onClick={loadMoreVideosHandler}
          className={button}
        >
          {t("media.video-section.button")}
        </button>
      ) : null}
    </div>
  );
};

export default VideoItems;
